import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			panel: {
				// height: '200px',
				width: '50%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			config: {
				sorting: true,
				fields: {
					code: {
						description: 'Код',
						config: {
							width: '150px',
							sorting: 'fizlica.code'
						}
					},
					name: {
						config: {
							visible: true,
							sorting: 'fizlica.name'
						}
					},
					pol: {

					}
				}
			},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				height: '500px',
				width: '70%'
			},
			config: {
				fields: {
					code: {
					},
					name: {
					}
				}
			},
			component: defineAsyncComponent(() => import('./forms/Select.vue'))
		}
	}
}